import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Currency from './tools/currency';

const DisplayPrice = ({ price, includeFrom, hideZeroMinorUnit, className }) => {
  const priceParts = Currency.parts(price);
  const priceIsRounded = !(priceParts[1] && parseInt(priceParts[1]) > 0);
  const showMinorUnit = !(priceIsRounded && hideZeroMinorUnit);
  let priceSpanClass;

  if (
    typeof navigator !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.platform) &&
    priceParts[0] > 999
  ) {
    priceSpanClass = 'long-length-price';
  }

  return (
    <span className={classNames('is-price', className, priceSpanClass)}>
      {includeFrom && <span className="from">From </span>}
      <span className="symbol">{Currency.symbol}</span>
      <span className="unit">{priceParts[0]}</span>
      {showMinorUnit && priceParts[1] && (
        <span className="decimal-mark">{Currency.decimalMark}</span>
      )}
      {showMinorUnit && <span className="fraction">{priceParts[1]}</span>}
    </span>
  );
};

DisplayPrice.displayName = 'DisplayPrice';
DisplayPrice.propTypes = {
  price: PropTypes.number.isRequired,
  includeFrom: PropTypes.bool,
  hideZeroMinorUnit: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

DisplayPrice.defaultProps = {
  includeFrom: false,
  hideZeroMinorUnit: false,
  className: null,
};

export default DisplayPrice;
